export default "__VITE_ASSET__Oiqlt40O__"